import React, { useEffect, useState } from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { Solution } from './components/Solution';
import { Features } from './components/Features';
import { Visualization } from './components/Visualization';
import { CallToAction } from './components/CallToAction';
import { Footer } from './components/Footer';
import { TermsModal } from './components/TermsModal';
import { PrivacyModal } from './components/PrivacyModal';
import { ContactModal } from './components/ContactModal';
import { TrustBadges } from './components/TrustBadges';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { InstitutionalQuote } from './components/InstitutionalQuote';
import { WhatsIncluded } from './components/WhatsIncluded';
import { Bonuses } from './components/Bonuses';
import { initializePixel, PixelPageView } from './utils/MetaPixel';
export function App() {
  const [activeModal, setActiveModal] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    try {
      // Initialize Meta Pixel when the app loads
      initializePixel();
      // Set the page title
      document.title = 'Fit AirFryer';
    } catch (err) {
      console.error('Error during initialization:', err);
      setError('Error initializing the application');
    }
  }, []);
  const openModal = (modalName: string) => {
    setActiveModal(modalName);
  };
  const closeModal = () => {
    setActiveModal(null);
  };
  if (error) {
    return <div className="p-8 bg-red-50 rounded-lg max-w-md mx-auto mt-10 text-center" data-id="element-0">
        <h2 className="text-xl font-bold text-red-700 mb-4" data-id="element-1">Error de carga</h2>
        <p className="text-gray-700 mb-4" data-id="element-2">{error}</p>
        <button onClick={() => window.location.reload()} className="bg-red-600 hover:bg-red-700 text-white font-medium py-2 px-4 rounded" data-id="element-3">
          Recargar página
        </button>
      </div>;
  }
  return <div className="flex flex-col min-h-screen w-full bg-white" data-id="element-4">
      {/* Track page views */}
      <PixelPageView data-id="element-5" />
      <main className="flex-grow" data-id="element-6">
        <Hero data-id="element-7" />
        <TrustBadges data-id="element-8" />
        <Problem data-id="element-9" />
        <Solution data-id="element-10" />
        <Bonuses data-id="element-11" />
        <InstitutionalQuote data-id="element-12" />
        <WhatsIncluded data-id="element-13" />
        <Features data-id="element-14" />
        <Testimonials data-id="element-15" />
        <Visualization data-id="element-16" />
        <FAQ data-id="element-17" />
        <CallToAction data-id="element-18" />
        <Footer onOpenModal={openModal} data-id="element-19" />
      </main>
      {activeModal === 'terms' && <TermsModal onClose={closeModal} data-id="element-20" />}
      {activeModal === 'privacy' && <PrivacyModal onClose={closeModal} data-id="element-21" />}
      {activeModal === 'contact' && <ContactModal onClose={closeModal} data-id="element-22" />}
    </div>;
}